import { format } from 'date-fns';

const compareDatesToday = (visitStartDate) => {
    const startDateDay = visitStartDate && format(new Date(visitStartDate), 'dd-MM-yyyy');
    const today = format(new Date(), 'dd-MM-yyyy');
    return startDateDay !== today;
};

export default compareDatesToday;